import { testSettingConstants } from "../constants/testSettingConstants"
import { testAdministrationConstants } from "../constants/testAdministrationConstants"

const initialState = {
  globalDefault: {},
  groupTestSettings: {},
  activeTestSettings: {},
  fetchingTestSettingsError: null,
  fetchingTestSettings: false,
  savingTestSettings: false,
  savingTestSettingsFailed: null,
  levelAboveSettings: null,
  // Test Administration state
  testAdministration: null,
  fetchingTestAdministration: false,
  fetchingTestAdministrationError: null
}

export function testSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS:
      return {
        ...state,
        fetchingTestSettings: true
      }

    case testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS_SUCCESS:
      return {
        ...state,
        globalDefault: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.FETCH_DEFAULT_TEST_SETTINGS_FAILED:
      return {
        ...state,
        fetchingTestSettingsError: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.FETCH_GROUP_TEST_SETTINGS:
      return {
        ...state,
        fetchingTestSettings: true
      }

    case testSettingConstants.FETCH_GROUP_TEST_SETTINGS_SUCCESS:
      return {
        ...state,
        groupTestSettings: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.FETCH_GROUP_TEST_SETTINGS_FAILED:
      return {
        ...state,
        fetchingTestSettingsError: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS:
      return {
        ...state,
        fetchingTestSettings: true
      }

    case testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS_SUCCESS:
      return {
        ...state,
        activeTestSettings: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.FETCH_ACTIVE_TEST_SETTINGS_FAILED:
      return {
        ...state,
        activeTestSettings: action.payload,
        fetchingTestSettings: false
      }

    case testSettingConstants.SAVE_TEST_SETTINGS:
      return {
        ...state,
        savingTestSettings: true
      }

    case testSettingConstants.SAVE_TEST_SETTINGS_SUCCESS:
      return {
        ...state,
        savingTestSettings: false
      }

    case testSettingConstants.SAVE_TEST_SETTINGS_FAILED:
      return {
        ...state,
        savingTestSettingsFailed: action.payload,
        savingTestSettings: false
      }

    case testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS:
      return {
        ...state,
        fetchingLevelAboveSettings: true
      }

    case testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS_SUCCESS:
      return {
        ...state,
        levelAboveSettings: action.payload,
        fetchingLevelAboveSettings: false
      }

    case testSettingConstants.FIND_LEVEL_ABOVE_TEST_SETTINGS_FAILED:
      return {
        ...state,
        fetchingTestSettingsError: action.payload,
        fetchingLevelAboveSettings: false
      }

    // Test Administration cases
    case testAdministrationConstants.FETCH_TEST_ADMINISTRATION:
      return {
        ...state,
        fetchingTestAdministration: true,
        fetchingTestAdministrationError: null
      }

    case testAdministrationConstants.FETCH_TEST_ADMINISTRATION_SUCCESS:
      return {
        ...state,
        testAdministration: action.payload,
        fetchingTestAdministration: false
      }

    case testAdministrationConstants.FETCH_TEST_ADMINISTRATION_FAILED:
      return {
        ...state,
        fetchingTestAdministrationError: action.payload,
        fetchingTestAdministration: false
      }

    default:
      return state
  }
}
